<template>
  <div class="timeline-calendar__row timeline-calendar__row--periods">
    <div
      v-for="period in periods"
      class="timeline-calendar__periods timeline-calendar__item"
      :data-grid-columns="gridColumnsCount(period)"
    >
      <div
        v-if="period?.type !== 'empty'"
        class="timeline-calendar__item-period"
      >
        <span class="tw-text-ellipsis tw-text-sm tw-font-medium">
          {{ period.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const model = defineModel({
  type: Object,
  required: true,
  default: () => ({}),
});

const periods = computed(() => model.value.grid.value.periods);
const gridColumnsCount = (period) => {
  return model.value.showDays ? period.days : period.weeks;
};
</script>

<style lang="scss" scoped>
.timeline-calendar__item-period {
  @apply tw-flex-1 tw-rounded tw-border-b-2 tw-border-yellow-300 tw-bg-yellow-100 tw-p-2 tw-px-4;
}
</style>
